import scrollTo from './scrollTo'

export default (msDuration, y = 0) => scrollTo(0, y, msDuration)
